"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepCardStep = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _ = require("../../..");

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("../StepCard.css");

var _styles = {
  "card": "StepCard__card___LI0aC",
  "title": "StepCard__title___3IZi8",
  "date": "StepCard__date___1q_HB",
  "chip-tag": "StepCard__chip-tag___393Mz",
  "step": "StepCard__step___1MmRI",
  "active": "StepCard__active___2Jj5i",
  "step-title": "StepCard__step-title___1qMha",
  "show-steps": "StepCard__show-steps___3lBjm",
  "show-hide-steps": "StepCard__show-hide-steps___2ThPx"
};

const styles = _bind.default.bind(_styles);

const StepCardStep = (0, _mobxReact.observer)(({
  className,
  children,
  stepNumber,
  title,
  dataTestId,
  active,
  learnMoreOnClick
}) => {
  const composed_classname = (0, _bind.default)(styles('step', className, {
    active
  }));
  return _react.default.createElement("div", {
    className: composed_classname,
    "data-testid": dataTestId
  }, _react.default.createElement("div", {
    className: styles('step-title'),
    onClick: learnMoreOnClick
  }, _react.default.createElement(_.Text, {
    text: `${stepNumber + 1} . ${title}`,
    variant: 'medium'
  }), _react.default.createElement(_.Icon, {
    dataTestId: `${dataTestId}-info-icon`,
    name: _.IconEnum.question_circle,
    color: _.Color.neutral._light_60
  })), active && children);
});
exports.StepCardStep = StepCardStep;